// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"ae4f1f6a","163":"9d49a049","176":"6f422841","253":"9ac24e70","261":"73c1e879","445":"5d8c7f5a","496":"f901f975","846":"3fb19c3a","874":"d34a9f2d","884":"e3dbb9e7","915":"3fec211f","995":"1af2abba"}[chunkId] + ".chunk.js";
};